<template>
	<my-dialog :visible.sync="showDialog" title="修改密码" dialog-type="form" :close-on-click-modal="false" @close="closeDialog">
		<div class="pwd-panel">
			<el-form ref="editForm" label-width="auto" :model="editForm" :rules="rules" class="demo-form-inline">
				<el-form-item label="原密码" prop="oldPwd">
					<el-input v-model="editForm.oldPwd" class="input_200px" size="small" type="password"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPwd">
					<el-input v-model="editForm.newPwd" class="input_200px" size="small" type="password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPwd">
					<el-input v-model="editForm.confirmPwd" class="input_200px" size="small" type="password"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import { UpdatePassWord } from "../../../api/userApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			saveloading: false,
			editForm: {
				oldPwd: "",
				newPwd: "",
				confirmPwd: ""
			},
			rules: {
				oldPwd: [
					{
						required: true,
						message: "请输入原密码",
						trigger: "blur"
					}
				],
				newPwd: [
					{
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					}
				],
				confirmPwd: [
					{
						required: true,
						message: "请输入确认密码",
						trigger: "blur"
					},
					{
						validator: (rule, value, callback) => {
							if (value !== this.editForm.newPwd) {
								callback(new Error("两次输入密码不一致!"));
							} else {
								callback();
							}
						},
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {},
	methods: {
		// 显示
		showChangePwdDialog() {
			this.showDialog = true;
		},

		// 点击保存
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.updatePassWord();
				} else {
					return false;
				}
			});
		},

		// 修改密码
		updatePassWord() {
			this.saveloading = true;
			UpdatePassWord(this.editForm)
				.then((res) => {
					this.saveloading = false;
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "修改成功！"
						});
						this.showDialog = false;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.saveloading = false;
					this.$message.error("修改失败，请稍后再试！");
				});
		},

		// 关闭
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss">
.pwd-panel {
	width: 100%;
	padding: 8px 10px 0;
	box-sizing: border-box;
}

::v-deep .demo-form-inline {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 4px;
}

/* 每行：label 与输入框紧靠，整行居中 */
::v-deep .demo-form-inline .el-form-item {
	display: flex;
	align-items: center;
	width: auto;
	margin-bottom: 14px;
}

::v-deep .demo-form-inline .el-form-item__label {
	width: auto;
	white-space: nowrap;
	text-align: right;
	padding-right: 10px;
	flex-shrink: 0;
}

::v-deep .demo-form-inline .el-form-item__content {
	margin-left: 0 !important;
	line-height: normal;
}

::v-deep .input_200px {
	width: 220px;
}

.up_img {
	width: 100px;
	height: 100px;
	position: relative;

	.ui_delete {
		position: absolute;
		font-size: 20px;
		color: #ff0000;
		top: 0px;
		right: 0px;
	}
}

::v-deep .el-upload--picture-card {
	width: 100px;
	height: 100px;
	line-height: 100px;
}

::v-deep .el-input.is-disabled .el-input__inner {
	background: none;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
	background: none;
}

::v-deep .el-input__inner {
	background: #ffffff;
	color: #606266;
	border: 0.0625rem solid #cfcfcf;
}
</style>
